/**
 * paginate.pipe.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Pipe, PipeTransform } from "@angular/core";

export interface Paginated {
  _pageLength : number;
  _pageIndex : number;
  _maxPage : number;
  _next : () => void;
  _previous : () => void;
  _goto : (page : number) => void;
}

@Pipe({name: "paginate", pure: false})
export class PaginationPipe implements PipeTransform
{
  public static DEFAULT_PER_PAGE : number = 20;

  public static updatePagination (
    arr : any[] & Paginated,
    perPage : number = PaginationPipe.DEFAULT_PER_PAGE
  ) : void
  {
    arr._pageLength = perPage;
    arr._maxPage = Math.ceil(arr.length / arr._pageLength);
    if (!Number.isInteger(arr._pageIndex))
    {
      arr._pageIndex = 0;
    }
    if ((typeof arr._next) !== "function")
    {
      arr._next =
        () => arr._pageIndex = Math.min(arr._pageIndex + 1, arr._maxPage - 1);
      arr._previous =
        () => arr._pageIndex = Math.max(arr._pageIndex - 1, 0);
      arr._goto =
        (page : number) => arr._pageIndex =
            ((page % arr._maxPage) + ((page < 0) ? arr._maxPage : 0));
    }
  }

  public static getPage<T> (arr : T[] & Paginated) : T[]
  {
    const offset : number = arr._pageIndex * arr._pageLength;
    return arr.slice(offset, offset + arr._pageLength);
  }

  public transform (
    value : any[] & Paginated,
    // current : number = 0,
    perPage : number = PaginationPipe.DEFAULT_PER_PAGE
  ) : any[]
  {
    if (!Array.isArray(value))
    {
      console.error("Cannot paginate non-array structure");
      return [];
    }

    PaginationPipe.updatePagination(value, perPage);
    return PaginationPipe.getPage(value);
  }
}

/**
 * 
 */
@Pipe({name: "onPage", pure: false})
export class PageQueryPipe implements PipeTransform
{
  public transform (
    value : any[] & Paginated,
    query : any
  ) : boolean
  {
    if (!Array.isArray(value))
    {
      console.error("Cannot query page non-array structure");
      return false;
    }
    if (query === "last")
    {
      return (value._pageIndex === value._maxPage);
    }
    if (query === "first")
    {
      return (value._pageIndex === 0);
    }
    if (query < 0)
    {
      query += value._maxPage;
    }
    return (value._pageIndex === query);
  }
}




// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/support/pipes/paginate.pipe.ts